import { useOfferFiltersState } from "../context/OfferFiltersContext";
import { useFilterTracking } from "../hooks/useFilterTracking";
import { toStringArray } from "../utils/buildQueryString";
import AccordionChevronIcon from "./AccordionChevronIcon";
import FilterBadge from "./FilterBadge";
import FilterContent from "./FilterContent";
import clsx from "clsx";
import React from "react";
export default function FilterSection({ filter, facet, isOpen, onToggle, }) {
    const { trackFilterOpen } = useFilterTracking();
    const { committedState } = useOfferFiltersState();
    const count = toStringArray(committedState[filter.id]).filter((v) => v).length;
    function handleToggle() {
        if (!isOpen) {
            trackFilterOpen(filter);
        }
        onToggle();
    }
    return (<div>
      <button type="button" onClick={handleToggle} className="w-full flex items-center justify-between py-[17px] text-left">
        <span className="flex items-center gap-2">
          {filter.label}
          {count > 0 && <FilterBadge count={count}/>}
        </span>
        <AccordionChevronIcon className={clsx("size-6", isOpen && "rotate-180")}/>
      </button>
      {isOpen ? (<div className="pb-4">
          <FilterContent filter={filter} facet={facet}/>
        </div>) : null}
    </div>);
}
